import React from 'react';

import './skeleton.scss';

interface SkeletonProps {
	width?: string;
	height?: string;
	borderRadius?: string;
	className?: string;
}

export default function Skeleton({ width, height, borderRadius, className }: SkeletonProps) {
	return (
		<div
			className={`skeleton ${className}`}
			style={{
				width: width || '100%',
				height: height || '20px',
				borderRadius: borderRadius || '4px',
			}}
		/>
	);
}
